import React, {useState, useEffect, useContext, useRef} from "react";
import {useParams} from "react-router-dom";
import ListPanel from '../administration/components/ListPanel';
import EditPanel from '../administration/components/EditPanel';
import {useHistory} from 'react-router-dom';
import {store} from '../../context/store';
import {INPUT_TYPE_TEXT} from "../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDBCONCATENATION} from "../../constants/input-types";
import {functions} from "../../constants/common-functions";
import {TRUE} from "../../constants/general-constants";
import {STRINGIFY} from "../../constants/general-constants";
import AdminListPanelGeographies from '../administration/components/AdminListPanelGeographies';
import {YES_NO_OPTIONS} from "../../constants/general-constants";
import EditButtonPanel from '../administration/components/EditButtonPanel';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import * as adminStyles from "./components/AdminStyles";

export default function AdministrationFloorZonesEdit(){
	
	const globalState = useContext(store);
	const history = useHistory(); 
	const [floorId, setFloorId] = useState("0");
	const [entityCode, setEntityCode] = useState("");
	const [entitySystemCode, setEntitySystemCode] = useState("");
	const [entityName, setEntityName] = useState("New Floor Zone");
	const [entityDescription, setEntityDescription] = useState("");
	const [entityAreaReportable, setEntityAreaReportable] = useState("");
	const [entityMeasurementUnitSqm, setEntityMeasurementUnitSqm] = useState("");
	
	const refFloorId = useRef(null);
	const refCode = useRef(null);
	const refSystemCode = useRef(null);
	const refName = useRef(null);
	const refDescription = useRef(null);
	const refAreaReportable= useRef(null);
	const refMeasurementUnitSqm= useRef(null);
	
	const id = useParams()["id"];
	
	useEffect(() => {
		loadData();
	}, [id]);
	
	const loadData = () => {
		const timer = setTimeout(() => {
			functions.getObjectFromAjax("/resolutionsoftwareplatform/floorzone?id=" + id, null, initialiseFields);
		}, 100);
	};
	
	const getEntityCode = () => {
		return refCode.current.value;
	};
	
	const getEntityName = () => {
		return refName.current.value;
	};
	
	const initialiseFields = (entity) => {
		
		const timer = setTimeout(() => {
			try{
				setFloorId(entity.floorId);
				setEntityCode(entity.code);
				setEntitySystemCode(entity.systemCode);
				setEntityName(entity.name);
				setEntityDescription(entity.description);
				setEntityAreaReportable(entity.areaReportable);
				setEntityMeasurementUnitSqm(entity.measurementUnitSqm);
				
				refFloorId.current.value=entity.floorId;
				refCode.current.value = entity.code;
				refSystemCode.current.value = entity.systemCode;
				refName.current.value = entity.name;
				refDescription.current.value = entity.description;
				refAreaReportable.current.value = entity.areaReportable;
				if(entity.measurementUnitSqm === true){
					refMeasurementUnitSqm.current.value="Y";
				}
				else{
					refMeasurementUnitSqm.current.value="N";
				}
			}
			catch(e){}
		}, 100);
	
		
	};
	
	const mainComponentRows = [
		{ref:refFloorId, id:"1", title:"Floor", inputType:INPUT_TYPE_SELECTFROMDBCONCATENATION, restUrl:"allfloors"},
		{ref:refCode, id:"2", title:"Code", inputType:INPUT_TYPE_TEXT},
		{ref:refSystemCode, id:"5", title:"System Code", inputType:INPUT_TYPE_TEXT},
		{ref:refName, id:"3", title:"Name", inputType:INPUT_TYPE_TEXT},
		{ref:refDescription, id:"4", title:"Description", inputType:INPUT_TYPE_TEXTAREA},
		{ref:refAreaReportable, id:"6", title:"Reportable Area", inputType:INPUT_TYPE_TEXT},
		{ref:refMeasurementUnitSqm, id:"7", title:"Meausured in SqM?", inputType:INPUT_TYPE_SELECT, options:YES_NO_OPTIONS}
	];
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"#f0f0f0",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	
	const contentPanel = {
		display:"flex",
		width:"100%",
		marginTop:'20px'
	};
	
	const getSubmitObject = () => {
		let tempMeasurementUnitSqm = false;
		
		if(refMeasurementUnitSqm.current.value === "Y"){
			tempMeasurementUnitSqm = true;
		}
		let submitObject = {
			id:id,
			floorId:refFloorId.current.value,
			code:refCode.current.value,
			systemCode:refSystemCode.current.value,
			name:refName.current.value,
			description:refDescription.current.value,
			areaReportable:refAreaReportable.current.value,
			measurementUnitSqm:tempMeasurementUnitSqm
		};
		
		return submitObject
	}
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolutionsoftwareplatform/floorzonesave", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		goCancel();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolutionsoftwareplatform/floorzonedelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const goCancel = () => {
		history.goBack();
	};

	return (
		
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
				<div style={adminStyles.administrationHeader}>
					Floor Zone Edit: {entityName}
				</div>
				<div style={contentPanel}>
					<EditPanel
					title="Main Details"
						componentRows = {mainComponentRows}
					/>
					
				</div>
				<EditButtonPanel
					id={id}
					goSubmit={goSubmit}
					goDelete={goDelete}
					goCancel={goCancel}
					checkCodeUrl="floorzones"
					getCodeFunction={getEntityCode}
					getNameFunction={getEntityName}
				/>
			</div>
			
	
	);
}